<template>
  <section class="nflc-wrapper">
    <div class="bg"></div>

    <div class="section timeline-wrap">
      <button class="arr pre" type="button" @click="onPrev">
        <img src="@/static/image/about-arr1.png" alt="prev" />
      </button>

      <div class="year-container">
        <div class="line"></div>
        <div class="years">
          <div
            v-for="(item, idx) in visibleMilestones"
            :key="item.year"
            :class="['item', { active: windowStart + idx === activeIndex }]"
            @mouseenter="setActive(windowStart + idx)"
            @click="setActive(windowStart + idx)"
          >
            <div class="year">
              <img class="about-yuan" src="@/static/image/about-yuan.png" alt="yuan" />
              <div class="inner">{{ item.year }}</div>
            </div>
            <div class="s-line"></div>
            <div class="circle"><div class="shape"></div></div>
          </div>
        </div>
      </div>

      <button class="arr next" type="button" @click="onNext">
        <img src="@/static/image/about-arr2.png" alt="next" />
      </button>
    </div>

    <div class="content section">
      <div class="left">
        <img class="about4" src="@/static/image/about4.png" alt="milestone" />
      </div>
      <div class="right">
        <div class="title">{{ current.year }}</div>
        <div class="diver"></div>
        <div class="desc">
          <p v-for="(line, i) in currentDesc" :key="`${current.year}-${i}`" :class="{ first: i === 0 }">{{ line }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MilestoneSection',
  data() {
    return {
      activeIndex: 0,
      windowStart: 0,
      windowSize: 5,
      milestones: [
        {
          year: '2024',
          desc: ['湖南省人力资源服务促进就业成效明显机构', '湖南省上市后备企业资源库', '长沙天心经开区诚信经营企业', '湘潭市两新领域示范性红色党建品牌']
        },
        {
          year: '2023',
          desc: ['全国第三批百家金牌劳动人事争议调解组织', '长沙市人力资源服务重点企业促进就业示范机构', 'HRoot 2022年度最佳人力资源服务机构', '2022年度湖南省人力资源服务高质量发展企业']
        },
        {
          year: '2022',
          desc: ['湘潭市红色党建品牌示范单位', '湖南省创业带动就业人力资源服务示范机构', '湖南省劳动人事争议金牌调解组织', '获评湖南省服务业数字基建重点项目']
        },
        { year: '2020', desc: ['获得“AAA企业信用等级证书”', '新增贵州、宁夏等多家分公司，服务网络持续扩大'] },
        { year: '2019', desc: ['获得“湘潭市年度建筑劳务10强企业”荣誉称号', '获得“A级（优秀）单位”荣誉称号'] },
        { year: '2018', desc: ['成立湘楚人力资源集团有限公司', '全新战略布局，开启品牌时代新篇章'] },
        { year: '2017', desc: ['成立湖南湘楚人力资源有限公司校园分公司'] },
        { year: '2016', desc: ['获得首届中国清洁文化节企业文化银奖', '成立邵阳、永州等多家分公司'] },
        { year: '2015', desc: ['更名为湖南湘楚人力资源有限公司', '成立娄底分公司、长沙分公司'] },
        { year: '2014', desc: ['获得中国清洁清洗行业等级资质国家一级资质'] },
        { year: '2012', desc: ['获得“著名劳务派遣品牌机构”荣誉称号', '成立湘潭市人力资源培训学校'] },
        { year: '2011', desc: ['生产外包服务项目正式启动，产品全面升级', '成立湖南湘楚环境物业管理有限公司'] },
        { year: '2009', desc: ['业务发展初具规模，服务外派雇员逾万人', '成立湖南湘人网络通信有限公司'] },
        { year: '2007', desc: ['获得“劳动保障诚信企业”荣誉称号', '引入核心管理层，组建精英团队'] },
        { year: '2006', desc: ['服务网络全面覆盖湘潭市范围，并辐射至长沙、株洲'] },
        { year: '2005', desc: ['获得“再就业先进企业”荣誉称号'] },
        { year: '2003', desc: ['湘潭市人力资源服务有限公司成立', '成立湖南湘楚人力资源有限公司'] }
      ]
    }
  },
  computed: {
    current() {
      return this.milestones[this.activeIndex]
    },
    currentDesc() {
      const locale = (this.$i18n && this.$i18n.locale) || 'zh-CN'
      const localizedDesc = this.$t(`milestoneSection.milestones.${this.current.year}.desc`)

      if (locale === 'en' && Array.isArray(localizedDesc)) {
        return localizedDesc
      }

      return this.current.desc
    },
    visibleMilestones() {
      return this.milestones.slice(this.windowStart, this.windowStart + this.windowSize)
    }
  },
  methods: {
    setActive(index) {
      this.activeIndex = index
      if (this.activeIndex < this.windowStart) {
        this.windowStart = this.activeIndex
      }
      const end = this.windowStart + this.windowSize - 1
      if (this.activeIndex > end) {
        this.windowStart = this.activeIndex - this.windowSize + 1
      }
    },
    onPrev() {
      if (this.activeIndex > 0) {
        this.setActive(this.activeIndex - 1)
      }
    },
    onNext() {
      if (this.activeIndex < this.milestones.length - 1) {
        this.setActive(this.activeIndex + 1)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.nflc-wrapper { width: 100%; background: #f5f9ff; padding-bottom: 80px; }
.bg { height: 420px; background: url('../../../../static/image/about-ryzz-bg.png') center/cover no-repeat; }
.section { width: 1200px; margin: 0 auto; }
.timeline-wrap { margin-top: -280px; display: flex; align-items: center; }
.arr { width: 40px; height: 40px; border: none; background: transparent; cursor: pointer; padding: 0; }
.arr img { width: 26px; height: 34px; }
.year-container { position: relative; flex: 1; margin: 0 28px; padding-top: 8px; }
.line { position: absolute; left: 0; right: 0; top: 86px; height: 1px; background: rgba(255, 255, 255, 0.5); }
.years { display: flex; justify-content: space-between; align-items: flex-start; }
.item { width: 91px; color: #fff; text-align: center; cursor: pointer; }
.year { position: relative; height: 91px; display: flex; align-items: center; justify-content: center; text-align: left;}
.about-yuan { width: 91px; height: 91px; display: none; }
.inner { position: absolute; }
.s-line { width: 1px; height: 20px; background: #fff; margin: 14px auto 2px; }
.circle .shape { width: 11px; height: 11px; border-radius: 50%; background: #fff; margin: 0 auto; }
.item.active { margin-top: -8px; }
.item.active .about-yuan { display: block; }
.item.active .s-line { height: 30px; background: #4f78e1; margin-top: 0; }
.item.active .circle .shape { background: #4f78e1; }
.content { margin-top: 52px; height: 300px; background: #fff; display: flex; }
.left { width: 400px; }
.about4 { width: 100%; height: 100%; object-fit: cover; }
.right { width: 720px; padding: 30px 32px; }
.title { color: #1c51a3; font-size: 64px; line-height: 1; text-align: left; }
.diver { width: 48px; height: 2px; background: #d8d8d8; margin-top: 14px; }
.desc { margin-top: 16px; color: #333; font-size: 16px; line-height: 1.6;text-align: left; }
.desc p { margin-top: 8px; }
.desc p.first { margin-top: 0; }
</style>
